import { useQuery } from '@tanstack/react-query';
import { currentIdentityKeys } from '@/domain/identity/queryKeys';
import { supabase } from '@/integrations/supabase/client';

export const useBusinessProfileIdentitySource = (userId?: string) =>
  useQuery({
    queryKey: currentIdentityKeys.businessProfile(userId),
    queryFn: async () => {
      const { data, error } = await supabase
        .from('business_profiles')
        .select('company_id, company_name, contact_person, email, phone, website, industry, business_type, company_size, address_line_1, address_line_2, city, state_province, postal_code, country, tax_id')
        .eq('user_id', userId!)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
    enabled: Boolean(userId),
    staleTime: 10 * 60 * 1000,
  });
